module.exports = __webpack_public_path__ + "img/icons-close.11ff07c.svg";